import type { Graph3DData, Graph3DPositionedNode } from '../core/graph.types';
import type { Graph3DLayoutConfig } from '../core/layout.types';

export function applyLayeredLayout<TNodeData = unknown>(
  data: Graph3DData<TNodeData>,
  config: Graph3DLayoutConfig = {}
): Graph3DPositionedNode<TNodeData>[] {
  const layerGap = config.layerGap ?? 220;
  const nodeGap = config.nodeGap ?? 120;
  const zGap = config.zGap ?? 24;
  const layers = new Map<number, typeof data.nodes>();

  data.nodes.forEach(node => {
    const depth = node.depth ?? 0;
    const layerNodes = layers.get(depth) ?? [];
    layerNodes.push(node);
    layers.set(depth, layerNodes);
  });

  return data.nodes.map(node => {
    const depth = node.depth ?? 0;
    const layerNodes = layers.get(depth) ?? [];
    const index = layerNodes.findIndex(item => item.id === node.id);
    const offset = (layerNodes.length - 1) * nodeGap * 0.5;
    const x =
      config.direction === 'TB' || config.direction === 'BT'
        ? index * nodeGap - offset
        : depth * layerGap;
    const y =
      config.direction === 'TB' || config.direction === 'BT'
        ? -depth * layerGap
        : -(index * nodeGap - offset);
    return {
      ...node,
      resolvedPosition: {
        x: node.position?.x ?? x,
        y: node.position?.y ?? y,
        z: node.position?.z ?? depth * zGap,
      },
      resolvedSize: {
        width: node.size?.width ?? 140,
        height: node.size?.height ?? 64,
        depth: node.size?.depth ?? 10,
      },
    };
  });
}
